const WGS84ToGCJ02 = (() => {
  // 常量
  const pi = 3.14159265358979324; // 圆周率
  const a = 6378245.0; // 地球半径（椭球长半轴半径）
  const ee = 0.00669342162296594323; // 偏心率平方

  /**
   * 判断是否在中国境内
   * @param {number} lng 经度
   * @param {number} lat 纬度
   * @returns {boolean}
   */
  function outOfChina(lng, lat) {
    return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55);
  }

  /**
   * 计算纬度偏移量
   * @param {number} x
   * @param {number} y
   * @returns {number}
   */
  function transformLat(x, y) {
    let ret =
      -100.0 +
      2.0 * x +
      3.0 * y +
      0.2 * y * y +
      0.1 * x * y +
      0.2 * Math.sqrt(Math.abs(x));
    ret +=
      (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;
    ret +=
      (20.0 * Math.sin(y * pi) + 40.0 * Math.sin(y / 3.0 * pi)) * 2.0 / 3.0;
    ret +=
      (160.0 * Math.sin(y / 12.0 * pi) +
        320.0 * Math.sin(y * pi / 30.0)) *
      2.0 / 3.0;
    return ret;
  }

  /**
   * 计算经度偏移量
   * @param {number} x
   * @param {number} y
   * @returns {number}
   */
  function transformLng(x, y) {
    let ret =
      300.0 +
      x +
      2.0 * y +
      0.1 * x * x +
      0.1 * x * y +
      0.1 * Math.sqrt(Math.abs(x));
    ret +=
      (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;
    ret +=
      (20.0 * Math.sin(x * pi) + 40.0 * Math.sin(x / 3.0 * pi)) * 2.0 / 3.0;
    ret +=
      (150.0 * Math.sin(x / 12.0 * pi) +
        300.0 * Math.sin(x / 30.0 * pi)) *
      2.0 / 3.0;
    return ret;
  }

  /**
   * WGS84 转 GCJ-02
   * @param {number} lng 原始经度 (WGS84)
   * @param {number} lat 原始纬度 (WGS84)
   * @returns {Array<number>} 返回转换后的经纬度 [lng, lat] (GCJ-02)
   */
  function wgs84ToGcj02(lng, lat) {
    if (outOfChina(lng, lat)) {
      // 如果不在中国范围内，返回原始坐标
      return [lng, lat];
    }

    const dLat = transformLat(lng - 105.0, lat - 35.0);
    const dLng = transformLng(lng - 105.0, lat - 35.0);
    const radLat = (lat / 180.0) * pi;
    let magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    const sqrtMagic = Math.sqrt(magic);
    const offsetLat =
      (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * pi);
    const offsetLng =
      (dLng * 180.0) / (a / sqrtMagic * Math.cos(radLat) * pi);
    const mgLat = lat + offsetLat;
    const mgLng = lng + offsetLng;
    return [mgLng, mgLat];
  }

  // 导出方法
  return {
    wgs84ToGcj02,
  };
})();
// 导出模块
export default WGS84ToGCJ02;
// 示例使用
// const wgs84Lng = 116.390660525; // WGS84 经度（北京）
// const wgs84Lat = 39.919378242;  // WGS84 纬度（北京）

// const gcj02 = WGS84ToGCJ02.wgs84ToGcj02(wgs84Lng, wgs84Lat);
// console.log("火星坐标系 (GCJ-02)：", gcj02); // 输出：[116.39686285020442, 39.921842147960874]



// WEBPACK FOOTER //
// ./src/utils/coordinate.js